import { render, staticRenderFns } from "./AzDistributorsEdit.vue?vue&type=template&id=3cb90793"
import script from "./AzDistributorsEdit.vue?vue&type=script&lang=js"
export * from "./AzDistributorsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports